module.exports = __webpack_public_path__ + "static/media/facebook-messenger.4729c11d.png";